import Vue from "vue";
import VueRouter, { RouteConfig, RouterView } from "vue-router";
import Secondary from "@/layout/secondary.vue";
import Blank from "@/layout/blank.vue";
import Main from "@/layout/main.vue";
Vue.use(VueRouter);

const modules = require.context("/src/views", true, /\.vue$/);

const MenuEnum = {
  CATALOGUE: "M",
  MENU: "C",
  BUTTON: "A",
};

const isExternal = (path: string) => {
  return /^(https?:|mailto:|tel:)/.test(path);
};

export function filterAsyncRoutes(routes: any[], firstRoute = true) {
  return routes.map((route) => {
    const routeRecord = createRouteRecord(route, true);
    routeRecord.children = [];
    if (route.children != null && route.children && route.children.length) {
      routeRecord.children = filterAsyncRoutes(route.children, false);
    }
    return routeRecord;
  });
}

export function createRouteRecord(route: any, firstRoute: boolean) {
  //@ts-ignore
  const routeRecord: RouteRecordRaw = {
    path: `/${route.paths}`,
    name: route.paths.replace(/\//g, "_"),
    meta: {
      hidden: !route.is_show,
      keepAlive: !!route.is_cache,
      title: route.name,
      perms: route.perms,
      query: route.params,
      icon: route.icon,
      type: route.type,
      activeMenu: route.selected,
      moduleName: route.module_name,
    },
  };
  if (firstRoute) {
    routeRecord.disabled = true;
  }
  switch (route.type) {
    case MenuEnum.CATALOGUE:
      routeRecord.component = firstRoute ? Main : RouterView;
      if (route.redirect) {
        routeRecord.redirect = `/${route.selected}`;
      }
      break;
    case MenuEnum.MENU:
      routeRecord.component = !route.component
        ? Blank
        : loadRouteView(route.component);
      break;
  }
  return routeRecord;
}

export function loadRouteView(component: string) {
  //@ts-ignore
  return (resolve: any) => require([`@/views/${component}`], resolve);
}

export function findFirstValidRoute(routes: any): string | undefined {
  for (const route of routes) {
    if (
      route.meta?.type == MenuEnum.MENU &&
      !route.meta?.hidden &&
      !isExternal(route.path)
    ) {
      return route.name as string;
    }
    if (route.children) {
      const name = findFirstValidRoute(route.children);
      if (name) {
        return name;
      }
    }
  }
}
const designRoutes: Array<RouteConfig> = [
  {
    path: "/design",
    name: "design",
    meta: {
      title: "设计",
      parentPath: "/design",
    },
    component: () => import("@/views/design/design.vue"),
  },
];

const constantRoutes: Array<RouteConfig> = [
  {
    path: "/error",
    redirect: "/error/404",
  },
  {
    path: "/shop/manage",
    name: "shopManage",
    meta: {
      title: "店铺列表测试",
    },
    component: () => import("@/views/shop/shop/lists-test.vue"),
  },
  {
    path: "/design/effect",
    name: "effect",
    meta: {
      title: "制作效果图",
    },
    component: () => import("@/views/design/effect.vue"),
  },
  {
    path: "/design/factory",
    name: "factory",
    meta: {
      title: "制作工厂图",
    },
    component: () => import("@/views/design/factory.vue"),
  },
  {
    path: "/design/factorytest",
    name: "factorytest",
    meta: {
      title: "制作工厂图-1",
    },
    component: () => import("@/views/design/factory-test.vue"),
  },
  {
    path: "/design/psd-preview",
    name: "psd_preview",
    meta: {
      title: "PSD预览",
    },
    component: () => import("@/views/design/psd-preview.vue"),
  },
  {
    path: "/design/preview",
    name: "preview",
    meta: {
      title: "设计预览",
    },
    component: () => import("@/views/design/preview.vue"),
  },
  {
    path: "/account",
    name: "account",
    component: Secondary,
    redirect: "/account/login",
    children: [
      {
        path: "/account/login",
        name: "login",
        meta: {
          title: "登录",
          parentPath: "/account",
        },
        component: () => import("@/views/account/login.vue"),
      },
    ],
  },
  {
    path: "/error",
    name: "error",
    component: Secondary,
    redirect: "/error/404",
    children: [
      {
        path: "/error/404",
        name: "error_404",
        meta: {
          title: "404",
          parentPath: "/error",
        },
        component: () => import("@/views/error/404.vue"),
      },
      {
        path: "/error/500",
        name: "error_500",
        meta: {
          title: "500",
          parentPath: "/error",
        },
        component: () => import("@/views/error/500.vue"),
      },
    ],
  },
  {
    path: "/UpgradeAfter/run",
    name: "UpgradeAfter",
    component: Secondary,
    redirect: "/UpgradeAfter/run",
    children: [
      {
        path: "/UpgradeAfter/run",
        name: "UpgradeAfter",
        meta: {
          title: "更新后执行内容",
          parentPath: "/UpgradeAfter",
        },
        component: () => import("@/views/setting/UpgradeAfter/index.vue"),
      },
    ],
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // routes: [...asyncRoutes, ...constantRoutes],
  routes: [...constantRoutes],
});

export default router;
